'use strict';

import ApiEndpoint from './api_endpoint';

export default class ListResponses extends ApiEndpoint {
  execute(callback = undefined, session = undefined, responseUuid = '') {
    if (session === undefined) {
      return this.session.get('/response/' + responseUuid, undefined, callback);
    }
    return session.get('/response/' + responseUuid, undefined, callback);
  }
}
